import { getColorFromSCSS } from '@/helpers/styles/getColorFromSCSS';

export const BLUR_DATA_URLS = {
  VV_RED: `data:image/svg+xml;base64,${Buffer.from(
    `
    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <defs>
        <filter id="blur" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="0.8"/>
        </filter>
        <radialGradient id="gradient" cx="40%" cy="30%" r="70%">
          <stop offset="0%" style="stop-color:${getColorFromSCSS('red')};stop-opacity:1" />
          <stop offset="60%" style="stop-color:${getColorFromSCSS('primary-red')};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${getColorFromSCSS('red-dark')};stop-opacity:1" />
        </radialGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#gradient)" filter="url(#blur)"/>
    </svg>
    `,
  ).toString('base64')}`,
} as const;
